import React from 'react';
import {
	TableHead, TableSortLabel, TableCell, TableRow, Checkbox, Tooltip, IconButton, Icon,
	Menu, MenuList, MenuItem, ListItemIcon, ListItemText,
	withStyles
} from '@material-ui/core';

import {
	getTableHeaderStyles
} from 'modules/common';

const styles = theme => ({
	root: {},
	actionsButtonWrapper: {
		position: 'absolute',
		top: 0,
		left: 64,
		width: 64,
		height: 63,
		zIndex: 10,
		background: theme.palette.background.paper,
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center'
	}
});

class CustomTableHead extends React.Component {
	state = {
		selectedMenu: null
	};

	createSortHandler = property => event => {
		this.props.onRequestSort(event, property);
	};

	openSelectedMenu = (event) => {
		this.setState({ selectedMenu: event.currentTarget });
	};

	closeSelectedMenu = () => {
		this.setState({ selectedMenu: null });
	};


	setCellProps = (cellValue) => {
		let b = {};
		chartData.backgrounds && chartData.backgrounds.map(bg => {
			if (bg.selectedBackgroundDataElement === value
				&& bg.selectedBackgroundFieldValue === cellValue) {
				b.style = { backgroundColor: bg.selectedBackgroundValue }
			}
		})
		console.log("cellValue", cellValue, cellValue === "Verify", label, value, b);
		return b;
		// className: classnames({
		// 	[this.props.classes.NameCell]: value === "Complete"
		// })
	}

	getTableHeader = (data) => {
		let tableHeader = [];

		if(data && data.datasets  && Array.isArray(data.datasets) && data.datasets.length>0){
		 
		if(data &&Array.isArray(data.columns)){
		data.columns.forEach(element => {
			if (element.checked) {
				let headerItem = {
					id:  '',
					name: '',
					label: '',
					desc: "",
					disablePadding: false,
					numeric: false,
					sort: true,
					...element
				}
				tableHeader.push(element)
			}
		});
	    }

		tableHeader.push({
			id: "actions",
			name: "actions",
			label: "Actions",
			desc: "subtitle",
			disablePadding: false,
			numeric: false,
			sort: false
		}) 
	  }

		return tableHeader;
	};

	render() {
		const { onSelectAllClick, order, orderBy, numSelected, rowCount, classes, hasCheckbox,
			headerstyle, subHeaderstyle, isTableSubHeader } = this.props;
		const { selectedMenu } = this.state;

		let tableHeader = this.getTableHeader(this.props.data);
		return <TableHead>
			<TableRow className="h-64">
				{hasCheckbox && <TableCell padding="checkbox" className="relative pl-4 sm:pl-12"
					style={getTableHeaderStyles(headerstyle, ["color"])}>
					<Checkbox
						style={getTableHeaderStyles(headerstyle, ["color"])}
						indeterminate={numSelected > 0 && numSelected < rowCount}
						checked={numSelected === rowCount}
						onChange={onSelectAllClick}
					/>
					{numSelected > 0 && (
						<div className={classes.actionsButtonWrapper}>
							<IconButton
								aria-owns={selectedMenu ? 'selectedMenu' : null}
								aria-haspopup="true"
								onClick={this.openSelectedMenu}
							>
								<Icon>{"more_horiz"}</Icon>
							</IconButton>
							<Menu
								id="selectedMenu"
								anchorEl={selectedMenu}
								open={Boolean(selectedMenu)}
								onClose={this.closeSelectedMenu}
							>
								<MenuList>
									<MenuItem
										onClick={() => {
											this.closeSelectedMenu();
										}}
									>
										<ListItemIcon className={classes.icon}>
											<Icon>{"delete"}</Icon>
										</ListItemIcon>
										<ListItemText inset primary="Remove" />
									</MenuItem>
								</MenuList>
							</Menu>
						</div>
					)}
				</TableCell>}
				{tableHeader.map(row => {
					return <TableCell
						align={row.id === 'actions'?'center':'left'}
						key={row.id}
						style={{ padding: "0px " }}
						sortDirection={orderBy === row.id ? order : false}>
						<div style={row.id !== 'actions'?{
							display: "block",
                            minWidth: row.id === 'itemDesciprtion' ? 300 : '',
							...getTableHeaderStyles(headerstyle, ["backgroundColor", "color", "textAlign", "fontSize"])

						}:{}}>
							{row.sort
								? <Tooltip
									title={"Sort"}
									placement={row.numeric ? 'bottom-end' : 'bottom-start'}
									enterDelay={300}
									style={{
										// display: "block",
                                         padding: "16px 0px 16px 0px",
										...getTableHeaderStyles(headerstyle, ["fontSize"])
									}}>
									<TableSortLabel
										active={orderBy === row.id}
										direction={order}
										onClick={this.createSortHandler(row.id)}>
										{row.label}
									</TableSortLabel>
								</Tooltip>
								: <Tooltip
									title={"Actions"}
									placement={row.numeric ? 'bottom-end' : 'bottom-start'}
									enterDelay={300}
									style={{
										// display: "block",
										padding: "16px 0px 16px 0px", ...getTableHeaderStyles(headerstyle, ["backgroundColor", "fontSize"])
									}}>
									<TableSortLabel
										active={orderBy === row.id}
										direction={order}>
										{row.label}
									</TableSortLabel>
								</Tooltip>
							}
						</div>
						{isTableSubHeader && <div style={{
							display: "block",
							...getTableHeaderStyles(subHeaderstyle, ["backgroundColor", "color", "textAlign", "fontSize"])
						}}>
							<TableSortLabel
								active={orderBy === row.id}
								direction={order}
								onClick={this.createSortHandler(row.id)}>
								{row.desc}
							</TableSortLabel>
						</div>}
					</TableCell>
				}, this)}
			</TableRow>
		</TableHead >
	}
}

export default withStyles(styles, { withTheme: true })(CustomTableHead);
